import { reactive } from 'vue'

const state = reactive({
  toasts: [],
  nextId: 0
})

const MAX_TOASTS = 3

export function useToast() {
  function addToast(message, type = 'error', duration = 5000) {
    const id = state.nextId++
    state.toasts.push({ id, message, type, duration })

    // Remove oldest if exceeded max
    while (state.toasts.length > MAX_TOASTS) {
      state.toasts.shift()
    }

    // Auto-remove after duration
    setTimeout(() => {
      removeToast(id)
    }, duration)

    return id
  }

  function removeToast(id) {
    const index = state.toasts.findIndex(t => t.id === id)
    if (index !== -1) {
      state.toasts.splice(index, 1)
    }
  }

  return {
    toasts: state.toasts,
    addToast,
    removeToast,
    error(message, duration) { return addToast(message, 'error', duration) },
    success(message, duration) { return addToast(message, 'success', duration) },
    info(message, duration) { return addToast(message, 'info', duration) }
  }
}
